import React from 'react';

import ReportsModule from '../reports/components/ReportsModule';
import InventoryPermissionGuard from './InventoryPermissionGuard';

export default function InventoryReportsModule() {
  return (
    <InventoryPermissionGuard
      permissions={[
        { resource: 'reports', action: 'view_sales_report' },
        { resource: 'reports', action: 'view_delivery_report' },
        { resource: 'reports', action: 'view_income_expense_report' },
      ]}
    >
      <ReportsModule />
    </InventoryPermissionGuard>
  );
}